import { useTranslation } from "react-i18next";

export default function CTASection() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 px-6 md:px-10 bg-background-100">
      <div className="max-w-[960px] mx-auto text-center">
        {/* Visual container */}
        <div className="mx-auto mb-14 max-w-[720px] rounded-3xl overflow-hidden relative">
          <img
            src="https://readdy.ai/api/search-image?query=Warm%20minimalist%20product%20still%20life%20photography%20of%20cream%20canvas%20tote%20bag%20with%20leather%20straps%20white%20ceramic%20vase%20dried%20pampas%20grass%20and%20soft%20beige%20scarf%20arranged%20on%20natural%20linen%20fabric%20gentle%20morning%20sunlight%20streaming%20through%20sheer%20curtains%20editorial%20elegance%20with%20organic%20shadows%20and%20peaceful%20atmosphere&width=1440&height=600&seq=cta-product-fresh-v3&orientation=landscape"
            alt="Hoobuy products lifestyle"
            className="w-full h-[280px] md:h-[360px] object-cover object-top"
          />
          <div className="absolute inset-0 bg-white/8"></div>
        </div>

        {/* Text */}
        <div className="space-y-1 mb-10">
          <p className="font-heading text-3xl md:text-5xl lg:text-5xl font-bold text-foreground-950 leading-tight">
            {t("cta.title_line1")}
          </p>
          <p className="font-heading text-3xl md:text-5xl lg:text-5xl italic font-light text-foreground-500 leading-tight">
            {t("cta.title_line2")}
          </p>
          <p className="font-heading text-3xl md:text-5xl lg:text-5xl italic font-light text-foreground-500 leading-tight">
            {t("cta.title_line3")}
          </p>
          <p className="font-heading text-3xl md:text-5xl lg:text-5xl font-bold text-foreground-950 leading-tight">
            {t("cta.title_line4")}
          </p>
        </div>

        {/* CTA Button */}
        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-2 px-12 py-4 rounded-full bg-foreground-950 text-white font-semibold text-lg hover:bg-foreground-800 transition-all duration-300 whitespace-nowrap cursor-pointer"
        >
          {t("cta.button")}
          <i className="ri-arrow-right-up-line text-xl"></i>
        </a>
      </div>
    </section>
  );
}